import * as XLSX from 'xlsx';
import { Verification } from '../../../types/verification';

export const exportVerifications = (
  verifications: Verification[],
  translations: any
) => {
  try {
    const rows = verifications.map((v) => ({
      [translations?.verificationApproval?.export?.fullName || 'Full Name']:
        v.userInfo.fullName,
      [translations?.verificationApproval?.export?.username || 'Username']:
        v.userName,
      [translations?.verificationApproval?.export?.userType || 'User Type']:
        v.userType,
      [translations?.verificationApproval?.export?.status || 'Status']:
        v.status,
      [translations?.verificationApproval?.export?.passportNumber ||
      'Passport Number']: v.userInfo.passportNumber,
      [translations?.verificationApproval?.export?.country || 'Country']:
        v.userInfo.country,
      [translations?.verificationApproval?.export?.email || 'Email']:
        v.userInfo.email,
      [translations?.verificationApproval?.export?.mobile || 'Mobile']:
        v.userInfo.mobileNumber,
      [translations?.verificationApproval?.export?.agentCompany ||
      'Agent/Company']: v.userInfo.agent,
      [translations?.verificationApproval?.export?.bankName || 'Bank Name']:
        v.bankInfo?.bankName || '',
      [translations?.verificationApproval?.export?.accountNumber ||
      'Account Number']: v.bankInfo?.accountNumber || '',
      [translations?.verificationApproval?.export?.swiftCode || 'SWIFT Code']:
        v.bankInfo?.swiftCode || '',
      [translations?.verificationApproval?.export?.bankBranch ||
      'Bank Branch']: v.bankInfo?.bankBranch || '',
      [translations?.verificationApproval?.export?.ifscCode || 'IFSC Code']:
        v.bankInfo?.ifscCode || '',
      [translations?.verificationApproval?.export?.createdAt || 'Created At']:
        new Date(v.createdAt).toLocaleString(),
      [translations?.verificationApproval?.export?.updatedAt || 'Updated At']:
        new Date(v.updatedAt).toLocaleString(),
      [translations?.verificationApproval?.export?.reviewedAt ||
      'Reviewed At']: v.reviewedAt
        ? new Date(v.reviewedAt).toLocaleString()
        : '',
      [translations?.verificationApproval?.export?.rejectionReason ||
      'Rejection Reason']: v.rejectionReason || '',
      [translations?.verificationApproval?.export?.contractUrl ||
      'Contract URL']: v.contractUrl || '',
    }));

    const ws = XLSX.utils.json_to_sheet(rows);

    // Set column widths
    ws['!cols'] = [
      { wch: 30 }, // Full Name
      { wch: 20 }, // Username
      { wch: 15 }, // User Type
      { wch: 15 }, // Status
      { wch: 20 }, // Passport Number
      { wch: 20 }, // Country
      { wch: 30 }, // Email
      { wch: 15 }, // Mobile
      { wch: 25 }, // Agent/Company
      { wch: 20 }, // Bank Name
      { wch: 20 }, // Account Number
      { wch: 15 }, // SWIFT Code
      { wch: 20 }, // Bank Branch
      { wch: 15 }, // IFSC Code
      { wch: 20 }, // Created At
      { wch: 20 }, // Updated At
      { wch: 20 }, // Reviewed At
      { wch: 30 }, // Rejection Reason
      { wch: 50 }, // Contract URL
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      wb,
      ws,
      translations?.verificationApproval?.export?.sheetName || 'Verifications'
    );

    const date = new Date().toISOString().split('T')[0];
    XLSX.writeFile(
      wb,
      `${
        translations?.verificationApproval?.export?.fileName ||
        'verifications'
      }-${date}.xlsx`
    );

    return true;
  } catch (error) {
    console.error('Error exporting verifications:', error);
    return false;
  }
};